import React from "react";
import { Box } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface StarRatingProps {
  rating: number;
  maxStars?: number;
  size?: "small" | "medium" | "large";
  filledColor?: string;
  emptyColor?: string;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  maxStars = 5,
  size = "medium",
  filledColor,
  emptyColor,
}) => {
  // Ensure rating is within bounds
  const validRating = Math.max(0, Math.min(rating, maxStars));

  // Size mapping
  const sizeMap = {
    small: 16,
    medium: 22,
    large: 32,
  };

  const iconSize = sizeMap[size];

  // Default colors from theme
  const defaultFilledColor = nawyTheme.nawy.colors.semantic.layer.accent;
  const defaultEmptyColor = nawyTheme.nawy.colors.primitives.grey[200];

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {Array.from({ length: maxStars }, (_, index) => {
        const isFilled = index < validRating;
        return (
          <StarRoundedIcon
            fontSize="small"
            key={index}
            sx={{
              fontSize: iconSize,
              color: isFilled
                ? filledColor || defaultFilledColor
                : emptyColor || defaultEmptyColor,
            }}
            viewBox="0 0 22 22"
          />
        );
      })}
    </Box>
  );
};

export default StarRating;
